/* eslint-disable import/prefer-default-export */
export const searchStatus = {
  SUCCESS: '수행완료',
  CONTINUE: '진행중',
  ERROR: '작업시간 초과',
};

export const patternName = {
  NULL: '패턴명 미설정',
};



// WEBPACK FOOTER //
// ./src/views/settings/log-analysis/Pattern/constant/patternDefine.js